export default __webpack_public_path__ + "static/media/logo-biglia_contornaW.ede96409.png";